import React, { Fragment, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./scss/styles.scss";
import { FLCareLookupRoutes } from "./Routes";
import "react-toastify/dist/ReactToastify.css";
import MainAppLayout from "./component/Layout/MainAppLayout";
import { ToastContainer } from "react-toastify";
import { Fade } from "react-bootstrap";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";

const MainApp: React.FC = () => {
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();
  const location = useLocation();
  const isV2 = location.pathname.startsWith("/v2");

  const toast = (
    <ToastContainer
      position="top-right"
      autoClose={4000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  );

  if (isV2) {
    return (
      <>
        {toast}
        <FLCareLookupRoutes />
      </>
    );
  }

  return (
    <>
      <MainAppLayout>
        {toast}
        <FLCareLookupRoutes />
      </MainAppLayout>
    </>
  );
};

export default MainApp;